var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / SendOutlined",
    clipPath: "url(#clip0_3304_14235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.9435 1.11989L-0.0760207 6.0738C-0.149199 6.094 -0.212426 6.14018 -0.255313 6.20298C-0.353403 6.34774 -0.317138 6.5462 -0.171046 6.64577L5.81485 10.721C5.90497 10.7823 6.02032 10.794 6.12021 10.7498L8.98982 9.52845L7.47674 12.2533C7.42361 12.3495 7.42186 12.464 7.47487 12.5587L10.9058 18.9479C10.9419 19.0148 11 19.0674 11.0693 19.0936C11.2327 19.1587 11.418 19.0779 11.4846 18.9132L18.327 1.54584C18.353 1.48215 18.3553 1.41015 18.339 1.34425C18.2899 1.1734 18.1142 1.07368 17.9435 1.11989ZM11.0302 16.1431L9.02921 12.4196L12.0567 6.97126C12.0802 6.92865 12.0843 6.87654 12.0641 6.83023C12.0288 6.74919 11.936 6.7118 11.8536 6.74567L6.12001 9.18856L2.63964 6.81853L16.1682 3.09994L11.0302 16.1431Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3304_14235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendOutlined);
export default __webpack_public_path__ + "static/media/send-outlined.1101e8f3707600f075152a0566a49e80.svg";
export { ForwardRef as ReactComponent };